import { Link } from 'react-router-dom';

import { Paper, styled } from '@mui/material';

export const StyledReportAboutItemLink = styled(Link)({
	textDecoration: 'none',
	display: 'flex',
	minHeight: '265px',
});

export const StyledReportAboutItemWrap = styled(Paper)({
	flex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	flexDirection: 'column',
	gap: '16px',
	borderRadius: '20px',
	padding: '16px',
	margin: '0 !important',
	overflow: 'hidden',
});

export const StyledReportAboutItemImage = styled('img')({
	width: '100%',
	height: 'calc(100% - 48px)',
	objectFit: 'cover',
	borderRadius: 10,
});
